export default __webpack_public_path__ + "static/carousel-2-dcc47960663405f34c0a84951aa65ba6.png";